import Image from 'next/image';
import ReactPlayer from 'react-player/lazy';
import { ForwardedRef, forwardRef, Fragment } from 'react';
import styled, { css } from 'styled-components';

import { useIsClient } from '@hooks/useIsClient';
import { device } from '@styles/mediaQuery';
import { Overlay } from '@components/atoms';

type SummaryProps = {
  videoId: string;
};

function Summary({ videoId }: SummaryProps, ref: ForwardedRef<HTMLDivElement>) {
  const isClient = useIsClient();

  const onVideoEnd = () => {};

  const showVideo = true;

  return (
    <Wrapper>
      <Cover>
        {showVideo ? (
          <StyledImg
            quality={80}
            fill
            alt="quality-service-is-our-low-image"
            src="/images/video-bg-1x.webp"
            priority
          />
        ) : (
          <Fragment>
            {isClient && (
              <ReactPlayer
                muted
                playing
                url={videoId}
                width="100%"
                height="100%"
                onEnded={onVideoEnd}
              />
            )}

            <OnVideoHover />
          </Fragment>
        )}
      </Cover>

      {showVideo && <Overlay ref={ref} />}
    </Wrapper>
  );
}

const Cover = styled.div`
  position: relative;
  top: -60px;

  overflow: hidden;
  height: 286px;

  ${device.mobileL(css`
    top: -99px;
    height: 400px;
  `)};

  ${device.tablet(css`
    top: -90px;
    height: 500px;
  `)};

  ${device.laptopS(css`
    height: 515px;
  `)};

  ${device.laptopL(css`
    height: 650px;
  `)};
`;

const Wrapper = styled.div`
  position: relative;

  width: 100%;
  overflow: hidden;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.black};
  height: 170px;

  z-index: 1;

  ${device.mobileL(css`
    height: 205px;
  `)}

  ${device.tablet(css`
    height: 320px;
  `)}


  ${device.laptopS(css`
    height: 344px;
  `)}

  ${device.laptopL(css`
    height: 484px;
  `)}
`;

const OnVideoHover = styled.div`
  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  left: 0;
`;

const StyledImg = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: fill;

  position: absolute;
  top: 0;
  left: 0;
`;

export default forwardRef<HTMLDivElement, SummaryProps>(Summary);
